import { useMemo } from 'react';
import type { Facility } from '../utils/utils';
import type { FacilityColumn } from './utils/facilityTableTypes';
import FacilitiesTable from './FacilitiesTable';

interface StackedSectionProps {
    label: string;
    count: number;
    facilities: Facility[];
    columns: FacilityColumn[];
    search: string;
    onRowClick?: (f: Facility) => void;
}

export default function StackedSection({
    label,
    count,
    facilities,
    columns,
    search,
    onRowClick,
}: StackedSectionProps) {
    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q) return facilities;
        return facilities.filter(
            (f) =>
                f.name.toLowerCase().includes(q) ||
                f.region?.toLowerCase().includes(q)
        );
    }, [facilities, search]);

    if (filtered.length === 0 && !search) return null;

    return (
        <section>
            <div className="mb-3 mt-1 flex items-center gap-2.5">
                <h3 className="text-xl font-semibold text-foreground">
                    {label}
                </h3>
                <span className="rounded-full bg-zinc-300 px-2 py-0.5 text-xs font-medium tabular-nums text-zinc-800">
                    {count}
                </span>
            </div>
            <FacilitiesTable
                facilities={filtered}
                columns={columns}
                emptyMessage={`No ${label.toLowerCase()} facilities found.`}
                onRowClick={onRowClick}
            />
        </section>
    );
}
